import { useContext } from 'react'
import { gql } from '@apollo/client'
import { useRouter } from 'next/router'
import { useMutationNext } from '../../componentsF/hooksF/useQueryNextF'
import { useToastOnError } from '../../componentsF/hooksF/useToastOnErrF.mts'
import { GameContext } from './GameContextF.jsx'
import { useGameRoom } from './common/GenericGamePage.jsx'
import { Ptext, Form1Control, Form1Label } from '../../componentsF/Chakra3F/ChakraF.jsx'
import { Box, Button, Switch } from '@chakra-ui/react'

const UpdateRoomSettingsMut = gql`
mutation ($gameRoom: String!, $jdataUpdates: RoomSettingsInput!) {
  updateRoomSettings(gameRoom: $gameRoom, jdataUpdates: $jdataUpdates)
}`

const ResecureRoomMut = gql`
mutation ($gameRoom: String!) {
  resecureRoom(gameRoom: $gameRoom)
}`

const ResetBlockedIpsMut = gql`
mutation ($gameRoom: String!) {
  resetBlockedIps(gameRoom: $gameRoom)
}`

export const HostSettingsPanel = ({onClose}) => {
  const router = useRouter()
  const {roomJdata, fetchGameUpdate, nonBlankStacksCount} = useContext(GameContext)
  const {gameRoom} = useGameRoom()

  const isPublicRoom = roomJdata?.isPublicRoom ?? false

  const [updateSettings, {loading, error}] = useMutationNext(UpdateRoomSettingsMut, {
    onCompleted: async () => {
      await fetchGameUpdate?.()
    }
  })

  const [resecureRoom, {loading: resecureLoading, error: resecureError}] = useMutationNext(ResecureRoomMut, {
    onCompleted: ({resecureRoom: newRoom}) => {
      if (newRoom) router.replace(`/${newRoom}`)
    }
  })

  const [resetBlockedIps, {loading: resetIpsLoading, error: resetIpsError}] = useMutationNext(ResetBlockedIpsMut, {
    onCompleted: () => fetchGameUpdate?.()
  })

  useToastOnError({error})
  useToastOnError({error: resecureError})
  useToastOnError({error: resetIpsError})

  const handleTogglePublic = (e) => {
    updateSettings({variables: {gameRoom, jdataUpdates: {isPublicRoom: e.target.checked}}})
  }

  const gameInProgress = nonBlankStacksCount > 0

  const handleResecure = () => {
    if (!window.confirm('This will disconnect all players and change the room URL. Continue?')) return
    resecureRoom({variables: {gameRoom}})
  }

  return <Box {...{p: 4}}>
    <Ptext {...{fontSize: '2xl', mb: 4}}>Room Settings</Ptext>

    <Form1Control {...{mb: 4, display: 'flex', alignItems: 'center'}}>
      <Form1Label {...{mb: 0}}>Public Room</Form1Label>
      <Switch {...{isChecked: isPublicRoom, onChange: handleTogglePublic, isDisabled: loading}} />
    </Form1Control>
    <Ptext {...{fontSize: 'xs', color: 'gray.400', mb: 6}}>
      Allow anyone to join via "Join Random Public Game"
    </Ptext>

    <Box {...{borderTop: '1px solid', borderColor: 'gray.600', pt: 4, mt: 4}}>
      <Ptext {...{fontSize: 'sm', color: 'gray.400', mb: 2}}>
        Change room URL to remove problem players
      </Ptext>
      <Button {...{
        onClick: handleResecure,
        isLoading: resecureLoading,
        isDisabled: gameInProgress,
        colorScheme: 'orange',
        size: 'sm',
      }}>
        Re-secure Room
      </Button>
      {gameInProgress && <Ptext {...{fontSize: 'xs', color: 'gray.500', mt: 1}}>
        Not available while game in progress
      </Ptext>}
    </Box>

    {roomJdata?.blockedIps?.length > 0 && <Box {...{borderTop: '1px solid', borderColor: 'gray.600', pt: 4, mt: 4}}>
      <Ptext {...{fontSize: 'sm', color: 'gray.400', mb: 2}}>
        {roomJdata.blockedIps.length} IP{roomJdata.blockedIps.length > 1 ? 's' : ''} blocked from joining
      </Ptext>
      <Button {...{
        onClick: () => resetBlockedIps({variables: {gameRoom}}),
        isLoading: resetIpsLoading,
        colorScheme: 'yellow',
        size: 'sm',
      }}>
        Reset Blocked IPs
      </Button>
    </Box>}
  </Box>
}
